import React, { useEffect } from 'react';

export default function Modal({ open, onClose, title, children, footer, width = 520 }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 100,
        background: 'rgba(20, 20, 18, 0.42)',
        display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
        paddingTop: '8vh', paddingBottom: '4vh',
        backdropFilter: 'blur(2px)'
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#fff', borderRadius: 12,
          width, maxWidth: 'calc(100vw - 32px)', maxHeight: '84vh',
          overflow: 'hidden', display: 'flex', flexDirection: 'column',
          boxShadow: '0 24px 48px rgba(0,0,0,0.18), 0 4px 12px rgba(0,0,0,0.08)'
        }}
      >
        <header className="flex items-start justify-between px-6 pt-5 pb-4 border-b"
                style={{ borderColor: '#F0EFE9' }}>
          <h3 className="text-[15px] font-semibold tracking-tight" style={{ color: '#1A1A1A' }}>{title}</h3>
          <button onClick={onClose} className="rounded-md p-1.5 hover:bg-[#F2F1ED]"
                  style={{ color: '#6B6B68', border: 'none', background: 'transparent', cursor: 'pointer' }}
                  aria-label="Close">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
              <path d="M3 3L11 11M11 3L3 11" />
            </svg>
          </button>
        </header>
        <div style={{ overflowY: 'auto', flex: 1 }} className="px-6 py-5">{children}</div>
        {footer && (
          <footer className="px-6 py-3.5 border-t flex items-center justify-end gap-2"
                  style={{ borderColor: '#F0EFE9', background: '#FBFBF8' }}>
            {footer}
          </footer>
        )}
      </div>
    </div>
  );
}

export function PrimaryButton({ children, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        background: '#1A1A1A', color: '#fff',
        fontSize: 12.5, fontWeight: 500,
        padding: '7px 14px', borderRadius: 6,
        border: 'none', cursor: 'pointer'
      }}
    >{children}</button>
  );
}

export function SecondaryButton({ children, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        background: '#fff', color: '#3A3A38',
        fontSize: 12.5, fontWeight: 500,
        padding: '7px 14px', borderRadius: 6,
        border: '1px solid #E0DFD9', cursor: 'pointer'
      }}
    >{children}</button>
  );
}
